import type { TLabel } from '@shared/types/label';

import { EllipsisVertical, Trash2 } from 'lucide-react';
import React from 'react';
import { Badge } from '@src/design-system/badge';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@src/design-system/popover';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { LabelColorPicker } from './label-form';
import labelApi from '../services/label-api';
import { CloseCircle, Edit2 } from 'iconsax-react';
import Loader from '../../loader';

interface LabelDropdownMenuProps {
  label: TLabel;
  toggleLabel?: (item: TLabel) => void;
  isSelected: boolean;
}
export const LabelDropdownMenu: React.FC<LabelDropdownMenuProps> = ({
  label,
  toggleLabel,
  isSelected,
}) => {
  const { mutate: deleteLabel, isPending: isDeletePending } =
    labelApi.useDelete();
  const { id, name, hexa_color } = label;

  return (
    <DropdownMenu>
      <Badge
        variant='customizable'
        style={{
          backgroundColor: hexa_color,
        }}
        className='text-[var(--mainText)] relative w-fit group box-border font-medium cursor-pointer
     hover:gap-2 py-1.5 px-4 hover:pl-2 hover:pr-6  items-center justify-center hover:justify-between
    transition-all duration-200 ease-in-out leading-[20px] rounded-xl h-fit'
        onClick={() => toggleLabel?.(label)}
      >
        <span>{name}</span>

        {isSelected ? (
          <CloseCircle
            size={16}
            className={`opacity-0 group-hover:opacity-100 absolute right-1 top-1/2 -translate-y-1/2 transition-opacity duration-200 h-full hover:scale-110`}
          />
        ) : (
          <DropdownMenuTrigger
            disabled={isSelected}
            className={`opacity-0 group-hover:opacity-100 absolute right-2 top-1/2 -translate-y-1/2 transition-opacity duration-200 h-full ${isSelected ? 'hidden' : ''
              }`}
          >
            <EllipsisVertical
              size={12}
              className='cursor-pointer'
            />
          </DropdownMenuTrigger>
        )}
      </Badge>

      <DropdownMenuContent className='p-0'>
        <Popover>
          <PopoverTrigger asChild>
            <button
              className='w-full text-left px-2 py-1 text-xs hover:bg-gray-50 flex items-center gap-2 text-gray-800 border-b border-primary-100 cursor-pointer'
              role='menuitem'
            >
              <Edit2
                variant='TwoTone'
                size={12}
              />
              Edit
            </button>
          </PopoverTrigger>
          <PopoverContent
            className='w-[250px] bg-white border rounded-lg p-0'
            withPortal={true}
            side='left'
          >
            <LabelColorPicker data={label} />{' '}
          </PopoverContent>
        </Popover>

        <button
          className='w-full text-left px-2 py-1 text-xs hover:bg-gray-50 flex items-center gap-2 text-red-500 cursor-pointer'
          role='menuitem'
          onClick={() => {
            deleteLabel({ id });
          }}
        >
          {isDeletePending ? (
            <Loader
              size={12}
              height='12px'
              color='#f05252'
            />
          ) : (
            <Trash2 size={12} />
          )}
          Remove
        </button>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
